import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import BrandLogo from '@/components/feature/BrandLogo';
import BrandLoader from '@/components/feature/BrandLoader';
import WhatsAppButton from './WhatsAppButton';
import LanguageToggle from './LanguageToggle';
import { brandAssets, comingSoonContent as c } from '@/mocks/brand';

export default function ComingSoonView() {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {loading && <BrandLoader fullScreen size={140} />}
      <main className="relative min-h-screen w-full overflow-hidden bg-background-950 text-foreground-50 font-sans">
        <div className="pointer-events-none absolute inset-0">
          <div className="absolute -top-40 -left-40 w-[520px] h-[520px] rounded-full bg-primary-600/30 blur-[120px]" />
          <div className="absolute top-1/3 right-0 w-[480px] h-[480px] rounded-full bg-secondary-600/25 blur-[120px]" />
          <div className="absolute -bottom-40 left-1/3 w-[600px] h-[300px] rounded-full bg-accent-500/20 blur-[120px]" />
          <div className="absolute bottom-16 left-0 right-0 h-px bg-gradient-to-r from-transparent via-accent-400/70 to-transparent" />
        </div>

        <header className="absolute top-0 right-0 z-10 p-4 md:p-6">
          <LanguageToggle />
        </header>

        <div className="relative mx-auto flex min-h-screen max-w-7xl flex-col lg:flex-row items-center gap-6 lg:gap-4 px-4 md:px-8 pt-20 pb-10 md:pt-24 md:pb-14">
          <section className="w-full lg:w-1/2 flex flex-col items-center text-center charvys-rise">
            <h1 className="sr-only">{t('comingSoonH1')}</h1>
            <BrandLogo className="w-full max-w-[300px] md:max-w-[440px] drop-shadow-[0_0_30px_rgba(56,189,248,0.35)]" />

            <p className="mt-8 md:mt-10 font-heading text-4xl sm:text-5xl md:text-6xl font-black tracking-wide bg-gradient-to-b from-foreground-50 to-foreground-300 bg-clip-text text-transparent">
              {t('comingSoonTitle')}
            </p>
            <div className="mt-3 flex w-full max-w-md items-center gap-4">
              <span className="h-px flex-1 bg-gradient-to-r from-transparent to-accent-400" />
              <span className="font-label text-sm md:text-lg tracking-[0.4em] text-foreground-200 whitespace-nowrap">
                {t('comingSoonTitleAlt')}
              </span>
              <span className="h-px flex-1 bg-gradient-to-l from-transparent to-accent-400" />
            </div>

            <p className="mt-6 max-w-md text-base md:text-xl leading-relaxed text-foreground-200">
              {t('comingSoonTaglineStart')}
              <strong className="text-accent-400 font-semibold">{t('comingSoonTaglineHighlight')}</strong>
              {t('comingSoonTaglineEnd')}
            </p>

            <div className="mt-8 md:mt-10">
              <WhatsAppButton label={t('comingSoonCta')} phone={c.phone} href={c.whatsappUrl} />
            </div>
          </section>

          <section aria-label="CHARVYS" className="w-full lg:w-1/2 flex justify-center lg:justify-end charvys-rise-delay">
            <div className="relative w-full max-w-[360px] md:max-w-[560px] aspect-[640/520] overflow-hidden">
              <img
                src={brandAssets.model}
                alt={t('comingSoonModelAlt')}
                title={t('comingSoonModelTitle')}
                width={1200}
                height={800}
                className="absolute top-0 right-0 h-auto w-[187.5%] max-w-none object-top"
              />
              <div className="absolute inset-x-0 bottom-0 h-1/4 bg-gradient-to-t from-background-950 to-transparent" />
            </div>
          </section>
        </div>
      </main>
    </>
  );
}